import { openBlock as t, createElementBlock as o, createElementVNode as e } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, a = /* @__PURE__ */ e("g", {
  fill: "currentColor",
  "clip-path": "url(#swap_svg__a)"
}, [
  /* @__PURE__ */ e("path", { d: "M3.85 8.514A.727.727 0 0 0 5.09 8V5.091h10.182a.727.727 0 0 0 0-1.455H5.09V.727A.727.727 0 0 0 3.849.213L.213 3.849a.727.727 0 0 0 0 1.029zm8.3-1.028A.727.727 0 0 0 10.91 8v2.91H.726a.727.727 0 1 0 0 1.454H10.91v2.909a.727.727 0 0 0 1.241.514l3.637-3.636a.727.727 0 0 0 0-1.029z" })
], -1), n = /* @__PURE__ */ e("defs", null, [
  /* @__PURE__ */ e("clipPath", { id: "swap_svg__a" }, [
    /* @__PURE__ */ e("path", {
      fill: "currentColor",
      d: "M0 0h16v16H0z"
    })
  ])
], -1), r = [
  a,
  n
];
function s(c, _) {
  return t(), o("svg", l, [...r]);
}
const d = { render: s };
export {
  d as default,
  s as render
};
